import { render } from "./container.components.vue?vue&type=template&id=6258826c&ts=true"
import script from "./container.components.vue?vue&type=script&lang=ts"
export * from "./container.components.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__